import React from 'react';
import { PortalProvider } from 'react-portal-hook';
import { MutableSnapshot, RecoilRoot } from 'recoil';
import { ErrorPageContent, ErrorPageContentState } from './store';
import { TooltipDisclaimer } from '~/common/components/ui-elements';
import styles from './index.module.scss';
import { colorWhite } from '~/common/utils';

export default React.memo((props: ErrorPageContent) => {
  const color = `#${props.contentFontColor || colorWhite}`;

  return (
    <RecoilRoot
      initializeState={({ set }: MutableSnapshot) => {
        set(ErrorPageContentState, { ...props });
      }}
    >
      <PortalProvider>
        <div className={styles.errorPage}>
          <div className={styles.errorImageContainer}>
            <img
              src={props.backgroundImage}
              className={styles.errorImageDesktop}
              loading="lazy"
            />
            <img
              src={props.mobileBackgroundImage}
              className={styles.errorImageMobile}
              loading="lazy"
            />

            <div className={styles.errorBody}>
              <div className={styles.errorTitle}>
                <div
                  className={styles.errorTitleText}
                  style={{
                    color,
                  }}
                  dangerouslySetInnerHTML={{ __html: props.title }}
                />
                {props.titleDisclaimer && (
                  <TooltipDisclaimer
                    className={styles.errorTitleDisclaimer}
                    disclaimer={props.titleDisclaimer}
                    color={color}
                  />
                )}
              </div>

              <span
                className={styles.errorBodyContent}
                style={{
                  color,
                }}
                dangerouslySetInnerHTML={{ __html: props.bodyContent }}
              />
            </div>

            {!!props.legalDisclaimer && (
              <div
                className={styles.errorImageDisclaimer}
                style={{
                  color: `#${props.legalDisclaimerFontColor || colorWhite}`,
                }}
                dangerouslySetInnerHTML={{ __html: props.legalDisclaimer }}
              />
            )}
          </div>
        </div>
      </PortalProvider>
    </RecoilRoot>
  );
});
